import { Component } from '@angular/core';

@Component({
  selector: 'app-bluecollar',
  templateUrl: './bluecollar.component.html',
  styleUrls: ['./bluecollar.component.css']
})
export class BluecollarComponent {

  ShowCard:any;
}
